import { render } from "./ClientJourneyEmptyState.vue?vue&type=template&id=50a7a68e&scoped=true"
import script from "./ClientJourneyEmptyState.vue?vue&type=script&lang=js"
export * from "./ClientJourneyEmptyState.vue?vue&type=script&lang=js"

import "./ClientJourneyEmptyState.vue?vue&type=style&index=0&id=50a7a68e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a7a68e"]])

export default __exports__